import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import { IStore } from '../../domain/store';
import { Dropdown, IDropdownItem } from './Dropdown';
import { OrganizationListItem } from './OrganizationListItem';
import ChevronDownSVG from './Icon/ChevronDown';

interface IProps {
  store?: IStore;
}

const CurrentOrganization = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 16px;
  height: 56px;
  cursor: pointer;
  user-select: none;
  min-width: 200px;
  pointer-events: auto;
`;

const ChevronDown = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

@inject('store')
@observer
export class OrganizationSelector extends React.Component<IProps, {}> {
  private store: IStore;

  constructor(props: IProps) {
    super(props);
    this.store = props.store!;
    this.onChange = this.onChange.bind(this);
  }

  public onChange(e: React.SyntheticEvent<HTMLElement>, selectedKey: string) {
    const { organizationStore } = this.store;
    e.stopPropagation();
    organizationStore.setSelectedOrganizationId(selectedKey);
  }

  public render() {
    const { organizationStore } = this.store;

    const TriggerComponent = (
      <CurrentOrganization>
        <OrganizationListItem
          name={organizationStore.selectedOrganization!.name}
          profileImageUrl={organizationStore.selectedOrganization!.profileImageUrl}
        />
        <ChevronDown>
          <ChevronDownSVG size={16} />
        </ChevronDown>
      </CurrentOrganization>
    );

    const Items: IDropdownItem[] = [];
    organizationStore.organizationList!.map(organization => {
      if (organization.id !== organizationStore!.selectedOrganizationId) {
        Items.push({
          key: organization.id,
          component: <OrganizationListItem name={organization.name} profileImageUrl={organization.profileImageUrl} />,
        });
      }
    });

    return (
      <Dropdown placement="bottom-end" triggerComponent={TriggerComponent} items={Items} onChange={this.onChange} />
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/OrganizationSelector.tsx